import { useEffect, useMemo, useState } from "react";
import { js_utils } from "../utils/frfr-js-utils";
import { pagination_utils } from "../utils/frfr-pagination-utils";


// useFrfrViewMultimode // TODO

/*
TODO

*/

// ----- view multimode defaults
const _FrfrViewMultimode_default_blueprint_row = {
  rowKeyExtractor: (row, row_index) => {
    // return row_index;
    return row?.id; // default row key is 'id'
  },
};
const _FrfrViewMultimode_default_blueprint_general = {
  // disableBlueprintCaching // TODO
  selectAllSelectOnlyVisible: true, // TODO
  pagination_enabled: true, // TODO
  pagination_rowsPerPageInitial: '', // TODO
};
// ----- view tablemode defaults
const _FrfrViewMultimode_tablemode_default_cellBlu = { // defaults for each cell in columns blueprint
  sortable: true,
  filterable: true,
  searchable: true, // TODO
};
const _FrfrViewMultimode_tablemode_default_blueprint_row = { // DUPLICATE
  rowKeyExtractor: (row, row_index) => {
    // return row_index;
    return row?.id; // default row key is 'id'
  },
};
const _FrfrViewMultimode_tablemode_default_blueprint_table = {
  showFilterRow: true, // TODO
  showSelectable: true, // TODO
  showSelectableSingular: false, // default false
  showSelectAll: true, // default true
  resizable: false, // TODO // default false
  resizableColumnMinWidth: 32, // minimum column width for resizable columns
};
const _FrfrViewMultimode_tablemode_default_blueprint_general = {
  // disableBlueprintCaching // TODO
  selectAllSelectOnlyVisible: true, // TODO
  pagination_enabled: true, // TODO
  pagination_rowsPerPageInitial: '', // TODO
  responsiveTable: false, // TODO
};
//
const _fix_cellBlueprint = (_cellBlu, col_index, defaultColumnBlueprint) => {
  if (typeof _cellBlu === 'string') {
    return {
      ..._FrfrViewMultimode_tablemode_default_cellBlu,
      ...defaultColumnBlueprint,
      key: _cellBlu, // TODO
      title: _cellBlu,
    };
  } else {
    // return _cellBlu;
    return {
      ..._FrfrViewMultimode_tablemode_default_cellBlu,
      ...defaultColumnBlueprint,
      ..._cellBlu,
    };
  }
};
//
const _fix_viewMultimodeBlueprint = (viewBlueprint) => {
  console.log('_fix_viewMultimodeBlueprint ...');
  let blueprintError = null;
  /*
  let fixed = {
    freshness: null,
    general: { ..._FrfrViewMultimode_default_blueprint_general, },
    row: { ..._FrfrViewMultimode_default_blueprint_row },
  };
  */
  let fixed = {
    freshness: null, // freshness of blueprint itself
    general: { ..._FrfrViewMultimode_tablemode_default_blueprint_general },
    table: { ..._FrfrViewMultimode_tablemode_default_blueprint_table }, // NOVO TODO preimenovati u tablemode
    defaultColumnBlueprint: {},
    columns: [], // array of cell blueprints to be filled with
    columns_lookup_obj: {}, //
    // TODO pomeriti gore posle general
    // row: { ..._FrfrViewMultimode_tablemode_default_blueprint_row }, // DUPLICATE
    row: { ..._FrfrViewMultimode_default_blueprint_row },
  };
  //
  if (js_utils.is_object(viewBlueprint)) {
    //
    if ('freshness' in viewBlueprint) {
      fixed.freshness = viewBlueprint.freshness;
    }
    //
    // let blueprintGeneral = {};
    if (js_utils.is_object(viewBlueprint?.general)) {
      fixed.general = viewBlueprint.general;
      fixed.general = {
        ..._FrfrViewMultimode_default_blueprint_general,
        ...viewBlueprint.general,
      };
    }
    //
    // let blueprintTable = {};
    // if (js_utils.is_object(props.blueprintTable)) {
    if (js_utils.is_object(viewBlueprint?.table)) {
      // blueprintTable = props.blueprintTable;
      fixed.table = viewBlueprint.table;
      fixed.table = {
        // ..._TableGenerator_default_blueprint_table,
        ..._FrfrViewMultimode_tablemode_default_blueprint_table,
        ...viewBlueprint.table,
      };
    }
    //
    //
    // let defaultColumnBlueprint = {};
    if (js_utils.is_object(viewBlueprint?.defaultColumnBlueprint)) {
      fixed.defaultColumnBlueprint = viewBlueprint.defaultColumnBlueprint;
    }
    // let blueprintColumns = [];
    if (Array.isArray(viewBlueprint?.columns)) {
      fixed.columns = viewBlueprint.columns;
      /*
      fixed.columns = fixed.columns.map((_cellBlu, col_index) => {
        return _fix_cellBlueprint(_cellBlu, col_index, fixed.defaultColumnBlueprint);
      });
      */
      let _fixed_columns_prepared = [];
      fixed.columns.forEach((_cellBlu, col_index) => {
        // return _fix_cellBlueprint(_cellBlu, col_index, fixed.defaultColumnBlueprint);
        const _fixed_cellBlu = _fix_cellBlueprint(_cellBlu, col_index, fixed.defaultColumnBlueprint);
        _fixed_columns_prepared.push(_fixed_cellBlu);
        fixed.columns_lookup_obj[_fixed_cellBlu.key] = _fixed_cellBlu;
      });
      fixed.columns = _fixed_columns_prepared;
    }
    //
    //
    // let blueprintRow = {};
    // if (js_utils.is_object(props.blueprintRow)) {
    if (js_utils.is_object(viewBlueprint?.row)) {
      // blueprintRow = props.blueprintRow;
      fixed.row = viewBlueprint.row;
      fixed.row = {
        // ..._TableGenerator_default_blueprint_row,
        ..._FrfrViewMultimode_default_blueprint_row,
        ...viewBlueprint.row,
      };
    }
    //
    //
    if (fixed.columns.length === 0) {
      blueprintError = 'ERROR: viewMultimodeBlueprint.columns has no items!'; //
    }
    //
    //
  } else {
    blueprintError = 'ERROR: invalid viewMultimodeBlueprint!';
  }
  return [fixed, blueprintError];
};


//
export const useFrfrViewMultimode = (_fetching, _viewMultimodeBlueprint, rowsData, dataFreshness, cbOnSelectionChange, cbOnSelectionChangeSingular) => {


  // ----- BLUEPRINT EXTRACT AND FIX
  const initial_viewBlueprint = _fix_viewMultimodeBlueprint(_viewMultimodeBlueprint);
  const [viewBlueprint, blueprintError] = initial_viewBlueprint;
  console.log('DEBUG viewBlueprint', viewBlueprint);
  const blueprintGeneral = viewBlueprint.general;
  const blueprintRow = viewBlueprint.row;
  const blueprintColumns = viewBlueprint.columns;
  const blueprintColumns_lookup_obj = viewBlueprint.columns_lookup_obj;
  // NOVO TODO
  const blueprintTable = viewBlueprint.table;
  const defaultColumnBlueprint = viewBlueprint.defaultColumnBlueprint;
  //
  let initial_rowsPerPage = '';
  if (blueprintGeneral.pagination_rowsPerPageInitial > 0) {
    initial_rowsPerPage = blueprintGeneral.pagination_rowsPerPageInitial;
  }
  //
  const rowKeyExtractor = blueprintRow.rowKeyExtractor;
  //
  const _cellValueExtractor = (row, column_key, col_index, row_index, cellBlu) => {
    // let _content;
    let val;
    const k = column_key;
    // console.log('k', k);
    if (cellBlu && cellBlu.cellValueExtractor && typeof cellBlu.cellValueExtractor === 'function') { // CASE cell content rendered by callback
      // _content = cellBlu.tdCb(row, k, col_index, row_index);
      val = cellBlu.cellValueExtractor(row, k, col_index, row_index);
    } else { // CASE cell content rendered regular
      val = row[k]; // TODO when cell content is primitive renderable value
    }
    // console.log('real cell val', val); // real cell val independent of display format
    return val;
  };


  // ----- state
  const [state, setState] = useState({
    // (filtered, sorted, paginated, selected)
    // filtering
    filteredColumns: {},
    // sorting
    sortingState: {},
    sortedColumnKey: null,
    // pagination
    // pagination_per_page: '', // TODO
    pagination_per_page: initial_rowsPerPage, // TODO
    pagination_page_no: 1,
    // selecting
    selectedRowKeys: [],
    selectedAllRows: null, // null or true (all selected) or false (none selected)
    selectedRowSingularKey: false, // false or row_key

    //
    showMoreColumns: false, // expand/show more columns
    // columnWidthState: {},
  });
  // const [sortingState, setSortingState] = useState({});
  // const [filteredColumns, setFilteredColumns] = useState({});
  // const [showMoreColumns, setShowMoreColumns] = useState(false); // expand/show more columns
  // const sortedColumnKey = sortingState.__sortByThisKey__;
  const {
    filteredColumns,

    sortingState,
    sortedColumnKey,

    // pagination_per_page, // will be extracted later
    pagination_page_no,

    selectedRowKeys,
    selectedAllRows,
    selectedRowSingularKey,

    //
    showMoreColumns,
    // columnWidthState,
  } = state;


  ////
  // NOVO 2022
  // ----- TableGenerator EXPAND MORE COLUMNS
  const _handleClickShowMoreColumns = (e) => {
    // setShowMore(true);
    setState(state => {
      return {
        ...state,
        showMoreColumns: true
      }
    });
  };
  //
  let _cols_before_more = 0;
  if (blueprintTable && blueprintTable.numberOfColumnsBeforeMore && blueprintTable.numberOfColumnsBeforeMore > 0) {
    _cols_before_more = blueprintTable.numberOfColumnsBeforeMore;
  }
  //
  const _isColumnRenderingEnabled = (col_index) => {
    if (showMoreColumns !== true && _cols_before_more > 0) { // SPECIAL MORE SECTION COLLAPSED
      const no = col_index + 1;
      if (no > _cols_before_more) { // CASE CELL IN SPECIAL MORE SECTION WHEN COLLAPSED
        return false; // not render this cell
      } else { // CASE in always display section 
        return true; // render this cell
      }
    }
    // CASE render all columns
    return true;
  };
  //
  const _is_column_index_first_in_special_more_section = (col_index) => {
    if (showMoreColumns !== true && _cols_before_more > 0) { // CASE SPECIAL MORE SECTION COLLAPSED
      const no = col_index + 1;
      if ((no - _cols_before_more) === 1) { // CASE BINGO! FIRST CELL IN SPECIAL MORE SECTION WHEN COLLAPSED
        return true; // BINGO!
      }
    }
    // CASE other cell
    return false; // other cell
  };
  ////


  // ---------- DATA PREPARING

  //
  let dataError = null;
  let initialRowsData = []; // rows data before filtering, sorting...
  let fetching = false;
  // let jsxSpinner = null;
  if (_fetching === true) {
    // jsxSpinner
    fetching = true;
  } else {
    if (Array.isArray(rowsData)) {
      initialRowsData = rowsData;
    } else {
      dataError = 'ERROR rowsData is not Array!';
    }
  }


  // STEP)
  // ----- INFO initial rows data (unfiltered, unsorted) is ready...


  // STEP) FILTERING is most efficient before sorting
  // ----- FILTERING by column filter string
  let filteredData = initialRowsData; // filtered rows are also visible rows
  if (true) {
    const rows_filtered = initialRowsData.filter((row_obj) => {
      let exclude_me = false; // in case there is no filters at all
      let filtered_columns = filteredColumns;
      let filtered_keys = Object.keys(filtered_columns);
      filtered_keys.forEach((k) => {
        // const val = row_obj[k];
        /*
        const cellBlu = blueprintColumns.find((_cellBlu) => {
          return _cellBlu?.key === k; // cellBlu.key;
        });
        */
        const cellBlu = blueprintColumns_lookup_obj[k];
        // console.log('cellBlu', cellBlu);
        const val = _cellValueExtractor(row_obj, k, null, null, cellBlu);
        let include_me = false;
        let is_value_searchable = false;
        if (typeof val === 'string' || js_utils.is_number(val)) {
          is_value_searchable = true;
        }
        const q = filtered_columns[k];
        if (typeof q === 'string' && q !== '') {
          // there is a filter
          // console.log('filter');
          if (is_value_searchable) {
            if (q === '*') {
              if (val === '' || val === null) {
                // not include
              } else {
                // include * everything except null or empty sting
                include_me = true;
              }
            } else {
              // .indexOf return index of the first occurrence of searchString found, or -1 if not found.
              if (val.toString().toUpperCase().indexOf(q.toString().toUpperCase()) > -1) {
                include_me = true;
              } else {
                // not include
              }
            }
          }
        } else {
          // there is no filter, always include
          include_me = true;
        }
        if (include_me === false) {
          exclude_me = true;
        }
      });
      if (exclude_me) {
        return false; // remove from array
      }
      return true; // all other stay
    });
    filteredData = rows_filtered;
  }
  //
  const _handleChangeColumnFilterString = (column_key, q) => {
    // let _q = false;
    setState(state => {
      if (typeof q === 'string' && q !== '') { // CASE entered string
        if (state.filteredColumns[column_key] !== q) {
          /*
          setFilteredColumns({
            ...filteredColumns,
            [column_key]: q
          });
          */
          return {
            ...state,
            filteredColumns: {
              ...state.filteredColumns,
              [column_key]: q
            },
            selectedAllRows: null, // also RESET selectedAllRows
            pagination_page_no: 1, // also RESET pagination_page_no
          };
        }
      } else { // CASE entered empty
        if (state.filteredColumns[column_key] !== false) {
          /*
          setFilteredColumns({
            ...filteredColumns,
            [column_key]: false
          });
          */
          /*
          return {
            ...state,
            filteredColumns: {
              ...state.filteredColumns,
              [column_key]: false
            }
          };
          */
          const updated_filteredColumns_cleaned = {
            ...state.filteredColumns,
            [column_key]: false
          };
          delete updated_filteredColumns_cleaned[column_key]; // CLEANUP
          return {
            ...state,
            filteredColumns: updated_filteredColumns_cleaned,
            selectedAllRows: null, // also RESET selectedAllRows
            pagination_page_no: 1, // also RESET pagination_page_no
          };
        }
      }
      //

    });
  };

  // ----- VISIBLE ROWS
  // const visibleRowsData = filteredData; // filtered rows are also visible rows


  // STEP) SORTING (after filtering sorting is more efficient)
  // ----- SORTING
  let sortedData = filteredData;
  if (typeof sortedColumnKey === 'string' && sortedColumnKey !== '') {
    // sortedData = initialRowsData.sort((a, b) => {
    sortedData = filteredData.sort((a, b) => {
      let order = 0;
      //
      /*
      const cellBlu = blueprintColumns.find((_cellBlu) => {
        return _cellBlu?.key === sortedColumnKey; // cellBlu.key;
      });
      */
      const cellBlu = blueprintColumns_lookup_obj[sortedColumnKey];
      // console.log('cellBlu', cellBlu);
      const a_val = _cellValueExtractor(a, sortedColumnKey, null, null, cellBlu);
      const b_val = _cellValueExtractor(b, sortedColumnKey, null, null, cellBlu);
      //
      // order = js_utils.compare_a_b_smart(a[sortedColumnKey], b[sortedColumnKey]); // ascending 
      order = js_utils.compare_a_b_smart(a_val, b_val); // ascending 
      if (sortingState[sortedColumnKey].asc === false) { // descending 
        if (order !== 0) {
          return order * -1; // descending 
        }
      }
      return order;
      ////
      /*
      if (a[sortedColumnKey] && b[sortedColumnKey]) {
        // if (sortingState[sortedColumnKey] && sortingState[sortedColumnKey].asc === true) {
        if (sortingState[sortedColumnKey] && typeof sortingState[sortedColumnKey].asc === 'boolean') {
          // ascending
          if (a[sortedColumnKey] < b[sortedColumnKey]) {
            order = -1;
            // return -1;
          }
          if (a[sortedColumnKey] > b[sortedColumnKey]) {
            order = 1;
            // return 1;
          }
        }
        if (sortingState[sortedColumnKey].asc === false) { // descending 
          if (order !== 0) {
            return order * -1; // descending 
          }
        }
        return order;
      }
      // a must be equal to b
      return 0;
      */
    });
  }
  //
  const _getColumnSortedState = (k, cellBlu) => { // k is column key or cell key
    let _column_sorted_state = {
      sortable: false,
      sorted: false,
      asc: null, // order ascending or descending
    };
    if (cellBlu?.sortable === true) {
      _column_sorted_state.sortable = true;
    }
    if (sortedColumnKey && sortedColumnKey === k) {
      _column_sorted_state.sorted = true;
    }
    if (sortingState[k] && sortingState[k].asc === true) {
      _column_sorted_state.asc = true;
    }
    if (sortingState[k] && sortingState[k].asc === false) {
      _column_sorted_state.asc = false;
    }
    return _column_sorted_state;
  };
  //
  const _handleClick_table_th_sort = (key) => {
    /*
    let ascending = true;
    if (sortingState[key] && sortingState[key].asc === true) {
      ascending = false;
    }
    setSortingState({
      ...sortingState,
      __sortByThisKey__: key,
      [key]: {
        asc: ascending
      }
    });
    */
    setState(state => {
      let ascending = true;
      if (sortingState[key] && sortingState[key].asc === true) {
        ascending = false;
      }
      return {
        ...state,
        sortedColumnKey: key,
        sortingState: {
          ...state.sortingState,
          [key]: {
            asc: ascending
          }
        }

      };
    });
  };


  // STEP) PAGINATION must be after sorting
  // ----- PAGINATION FILTERING
  let currentPageData = sortedData;
  let pagination_per_page = '';
  if (state.pagination_per_page > 0) {
    pagination_per_page = state.pagination_per_page;
  }
  const size = sortedData.length;
  // const page_no = pagination_page_no;
  const pagination_prev_page_no = pagination_utils.prev_page_no_get(size, pagination_per_page, pagination_page_no);
  const pagination_next_page_no = pagination_utils.next_page_no_get(size, pagination_per_page, pagination_page_no);
  const pagination_pages_count = pagination_utils.pages_count_get(size, pagination_per_page);
  if (pagination_per_page > 0) { // CASE pagination enabled
    /*
    currentPageData = sortedData.filter((item, item_index) => {
      return pagination_utils.is_item_in_page(pagination_per_page, pagination_page_no, item_index);
    });
    */
    currentPageData = pagination_utils.array_filter_only_items_in_page(pagination_per_page, pagination_page_no, sortedData)
  }

  //
  const visibleRowsData = currentPageData; // currentPageData rows are also visible rows


  //
  // pagination handlers
  //
  const _handleChangePagination_rowsPerPage = (pagination_per_page) => {
    setState(state => {
      let _pagination_rowsPerPage = '';
      if (Number?.parseInt(pagination_per_page) > 0) {
        _pagination_rowsPerPage = Number.parseInt(pagination_per_page);
      }
      return {
        ...state,
        pagination_per_page: _pagination_rowsPerPage,
        pagination_page_no: 1, // also RESET pagination_page_no
      };
    });
  };
  //
  const _handleClickPaginationPagePrev = () => {
    setState(state => {
      let prevPageNo = 1;
      if ((state.pagination_page_no - 1) > 0) {
        prevPageNo = (state.pagination_page_no - 1);
      }
      return {
        ...state,
        pagination_page_no: prevPageNo,
      };
    });
  };
  //
  const _handleClickPaginationPageNext = () => {
    setState(state => {
      return {
        ...state,
        pagination_page_no: state.pagination_page_no + 1,
      };
    });
  };


  // PAGINATION useEffect
  useEffect(() => {
    if (fetching === true) { // RESET RESET pagination_page_no
    } else { // TODO
    }
    setState(state => {
      return {
        ...state,
        pagination_page_no: 1, // also RESET pagination_page_no
      };
    });
  }, [fetching, dataFreshness]);


  // STEP) SELECTION must be after pagination
  // -----
  //
  const _handleClickSelectAllRows = (singularMode) => {
    console.log('DEBUG is singularMode', singularMode === true);
    if (singularMode === true) { // singularMode
      // if (blueprintTable.showSelectableSingular === true) {
      if (true) {
        setState(state => {
          return {
            ...state,
            selectedRowSingularKey: false,
          };
        });
      }
    } else { // multiple
      // if (blueprintTable.showSelectable === true) {
      if (true) {
        setState(state => {
          let selectedRowKeys = [];
          let selectedAllRows = true; // null or false become true
          console.log('DEBUG state.selectedAllRows', state.selectedAllRows);
          if (state.selectedAllRows === true) { // CASE UNSELECT ALL
            selectedAllRows = false; // true become false
            //
            console.log('DEBUG blueprintGeneral.selectAllSelectOnlyVisible', blueprintGeneral.selectAllSelectOnlyVisible);
            if (blueprintGeneral.selectAllSelectOnlyVisible !== true) { // CASE UNSELECT all visile and invisible
              selectedRowKeys = []; // empty all selected
            } else { // CASE UNSELECT all only visible
              //
              let updated_selectedRowKeys_all = [];
              updated_selectedRowKeys_all = [...state.selectedRowKeys]; // preserve already selected rows
              //
              // STEP make visibleRowsKeys
              const visibleRowsKeys = [];
              visibleRowsData.forEach((row, row_index) => {
                if (typeof rowKeyExtractor === 'function') {
                  const row_key = rowKeyExtractor(row, row_index);
                  if (js_utils.is_number_or_string_not_empty(row_key)) { // valid keys only
                    if (visibleRowsKeys.includes(row_key)) { // CASE already included
                      // do nothing
                    } else { // CASE not included
                      visibleRowsKeys.push(row_key);
                    }
                  }
                } else {
                  // ERROR
                }
              });
              //
              // STEP filter out visible keys form selected keys
              const updated_selectedRowKeys_all_2 = updated_selectedRowKeys_all.filter((row_key) => {
                if (visibleRowsKeys.includes(row_key)) { // CASE visible row
                  return false; // UNSELECT visible row
                } else { // CASE not visible row
                  return true; // preserve selected invisible rows
                }
              });
              selectedRowKeys = updated_selectedRowKeys_all_2;
              //
            }
          } else { // CASE SELECT ALL
            selectedAllRows = true; // null or false become true
            //
            let updated_selectedRowKeys_all = [];
            updated_selectedRowKeys_all = [...state.selectedRowKeys]; // preserve already selected rows
            let rowsDataForSelectAll = initialRowsData;
            if (blueprintGeneral.selectAllSelectOnlyVisible === true) { // CASE select all only visible
              rowsDataForSelectAll = visibleRowsData; // filtered rows are also visible rows
            } else { // CASE select all visile and invisible
              rowsDataForSelectAll = initialRowsData;
            }
            console.log('DEBUG rowsDataForSelectAll', rowsDataForSelectAll);
            rowsDataForSelectAll.forEach((row, row_index) => {
              if (typeof rowKeyExtractor === 'function') {
                const row_key = rowKeyExtractor(row, row_index);
                if (js_utils.is_number_or_string_not_empty(row_key)) { // valid keys only
                  if (updated_selectedRowKeys_all.includes(row_key)) { // CASE already included
                    // do nothing
                  } else { // CASE not selected
                    updated_selectedRowKeys_all.push(row_key);
                  }
                }
              } else {
                // ERROR
                console.log('ERROR rowKeyExtractor is not a function');
              }
            });
            selectedRowKeys = updated_selectedRowKeys_all;
            //
          }
          console.log('DEBUG selectedAllRows', selectedAllRows);
          console.log('DEBUG selectedRowKeys', selectedRowKeys);
          return {
            ...state,
            selectedAllRows,
            selectedRowKeys,
          };
        });
      }
    }
  };
  //
  const _handleClickSelectRow = (row_key, singularMode) => {
    console.log(row_key);
    if (js_utils.is_number_or_string_not_empty(row_key)) { // valid keys only
      if (singularMode === true) { // singularMode
        // if (blueprintTable.showSelectableSingular === true) {
        if (true) {
          setState(state => {
            return {
              ...state,
              selectedRowSingularKey: row_key,
            };
          });
        }
      } else { // multiple
        // if (blueprintTable.showSelectable === true) {
        if (true) {
          setState(state => {
            let updated_selectedRowKeys = [];
            let bingo = false;
            state.selectedRowKeys.forEach((_row_key) => {
              if (_row_key === row_key) { // BINGO remove from selection
                bingo = true; // prevent another bingo
              } else { // all other stay
                updated_selectedRowKeys.push(_row_key);
              }
            });
            if (bingo === false) { // add to selection
              updated_selectedRowKeys.push(row_key);
            }
            return {
              ...state,
              selectedRowKeys: updated_selectedRowKeys,
              selectedAllRows: null, // also RESET selectedAllRows
            };
          });
        }
      }
    }
  };
  //
  const _handleClickSelectReset = () => {
    setState(state => {
      return {
        ...state,
        selectedRowKeys: [],
        selectedAllRows: null, // null or true (all selected) or false (none selected)
        selectedRowSingularKey: null,
      };
    });
  };
  //
  const _isRowSelected = (row_key, singularMode) => {
    if (singularMode === true) { // singularMode
      if (selectedRowSingularKey !== false && selectedRowSingularKey === row_key) {
        return true;
      } else {
        return false;
      }
    } else { // multiple
      /*
      if (selectedAllRows === true) {
        return true;
      }
      */
      // console.log(selectedRowKeys);
      return selectedRowKeys.includes(row_key);
      /*
      if (selectedRowKeys.includes(row_key)) {
        return true;
      } else {
        return false;
      }
      */
    }
  };


  // SELECTION useEffect
  useEffect(() => {
    if (typeof cbOnSelectionChange === 'function') { // multiple
      // sending all rows regardles if they visible or not
      if (selectedAllRows === true) {
        /*
        // cbOnSelectionChange(true); // TODO
        const _selectedRowKeys_all_for_sending = initialRowsData.map((row, row_index) => {
          if (typeof rowKeyExtractor === 'function') {
            return rowKeyExtractor(row, row_index);
          } else {
            return null; // ERROR
          }
        });
        cbOnSelectionChange(_selectedRowKeys_all_for_sending); //
        */
        cbOnSelectionChange(selectedRowKeys);
      } else {
        cbOnSelectionChange(selectedRowKeys);
      }
    }
    if (typeof cbOnSelectionChangeSingular === 'function') { // singularMode
      if (selectedRowSingularKey === false) {
        cbOnSelectionChangeSingular(null); // none selected singularMode
      } else {
        cbOnSelectionChangeSingular(selectedRowSingularKey); // selected singularMode row
      }
    }
  }, [selectedRowKeys, selectedAllRows, selectedRowSingularKey]);


  // SELECTION useEffect
  useEffect(() => {
    if (fetching === true) { // RESET selected rows on fetching
      _handleClickSelectReset();
    } else { // TODO
      _handleClickSelectReset(); // TODO
    }
  }, [fetching]);


  // STEP) END - data is ready (filtered, sorted, paginated, selected)
  // ---------- DATA IS READY
  // const rowsFinalReadyArr = sortedData;
  const rowsFinalReadyArr = currentPageData;
  let isZeroItemsFinalReadyArr = false;
  if (rowsFinalReadyArr.length === 0) {
    isZeroItemsFinalReadyArr = true;
  }
  const selectedAllRowsChecked = selectedAllRows; // TODO
  const selectedRowsCount = selectedRowKeys.length;

  const paginationPack = {
    pagination_per_page, // TODO
    pagination_page_no,
    pagination_prev_page_no,
    pagination_next_page_no,
    pagination_pages_count,
    _handleChangePagination_rowsPerPage,
    _handleClickPaginationPagePrev,
    _handleClickPaginationPageNext,
  };

  //
  return {
    // data
    fetching,
    dataError,
    rowsFinalReadyArr,
    isZeroItemsFinalReadyArr,

    // filtering
    _handleChangeColumnFilterString,

    // sorting
    _getColumnSortedState,
    _handleClick_table_th_sort,

    // pagination
    paginationPack,

    // selection
    selectedAllRowsChecked,
    selectedRowsCount,
    _isRowSelected,
    _handleClickSelectRow,
    _handleClickSelectAllRows,
    _handleClickSelectReset,

    // utils
    blueprintError,
    blueprintGeneral,
    blueprintTable,
    blueprintColumns,
    blueprintColumns_lookup_obj,
    blueprintRow,
    _cellValueExtractor, // NOVO 
    // TableGenerator
    _isColumnRenderingEnabled,
    _handleClickShowMoreColumns,
    _is_column_index_first_in_special_more_section,
  };
};